import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  Card,
  Row,
  Col,
  Select,
  DatePicker,
  Input,
  Button,
  Collapse,
  Table,
  Tag,
  Spin,
  Pagination,
  Icon,
  notification,
} from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { connect } from 'react-redux'
import Request, {
  productionStatusList,
  getProductionStatusColor,
} from '../../../request'
import ReviewModal from './reviewModal'
import styles from './styles.less'

const { Option } = Select
const { RangePicker } = DatePicker
const { Panel } = Collapse

const fmt = (d) => (d ? moment(d).format('ll') : '-')

const plural = (n, word) => `${n} ${word}${Number(n) === 1 ? '' : 's'}`

class OutwardOrderList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      orders: [],
      total: 0,
      page: 1,
      pageSize: 10,
      activeKeys: [],
      // filters
      dateRange: null,
      subCategory: undefined,
      user: undefined,
      orderId: '',
      status: undefined,
      // modal (date-driven)
      modalVisible: false,
      activeGroup: null,
    }
  }

  componentDidMount() {
    this.fetchList()
  }

  buildParams = () => {
    const { page, pageSize, dateRange, subCategory, user, orderId, status } =
      this.state
    const params = { page: page, count: pageSize, results: pageSize }
    if (dateRange && dateRange.length === 2) {
      params.startDate = dateRange[0].startOf('day').toISOString()
      params.endDate = dateRange[1].endOf('day').toISOString()
    }
    if (subCategory) params.subCategory = subCategory
    if (user) params.user = user
    if (orderId) params.orderId = orderId
    if (status) params.status = status
    return params
  }

  fetchList = () => {
    this.setState({ loading: true })
    Request.outwardOrderList(this.buildParams()).then((res) => {
      const { error, data, total } = res || {}
      if (!error) {
        const orders = data || []
        this.setState({
          loading: false,
          orders: orders,
          total: total || orders.length,
          activeKeys: this.computeGroupKeys(orders),
        })
      } else {
        this.setState({ loading: false, orders: [], total: 0 })
        notification.error({ message: 'Failed to load outward orders' })
      }
    })
  }

  computeGroups = (orders) => {
    const map = {}
    orders.forEach((o) => {
      const key = o.captureDate
        ? moment(o.captureDate).format('YYYY-MM-DD')
        : 'unknown'
      if (!map[key]) map[key] = []
      map[key].push(o)
    })
    const keys = Object.keys(map).sort((a, b) => {
      if (a === 'unknown') return 1
      if (b === 'unknown') return -1
      return moment(b, 'YYYY-MM-DD').valueOf() - moment(a, 'YYYY-MM-DD').valueOf()
    })
    return keys.map((k) => ({
      key: k,
      label: k === 'unknown' ? 'Unknown Date' : moment(k, 'YYYY-MM-DD').format('DD MMM YYYY'),
      orders: map[k],
      photosCount: map[k].reduce((s, o) => s + (Number(o.photosCount) || 0), 0),
      videosCount: map[k].reduce((s, o) => s + (Number(o.videosCount) || 0), 0),
      mediaCount: map[k].reduce(
        (s, o) => s + (Number(o.photosCount) || 0) + (Number(o.videosCount) || 0),
        0
      ),
    }))
  }

  computeGroupKeys = (orders) => this.computeGroups(orders).map((g) => g.key)

  handleSearch = () => {
    this.setState({ page: 1 }, this.fetchList)
  }

  handleReset = () => {
    this.setState(
      {
        dateRange: null,
        subCategory: undefined,
        user: undefined,
        orderId: '',
        status: undefined,
        page: 1,
      },
      this.fetchList
    )
  }

  onPageChange = (page, pageSize) => {
    this.setState({ page: page, pageSize: pageSize }, this.fetchList)
  }

  // Date-driven: open the viewer for a whole capture-date group
  openGroup = (group) => {
    this.setState({
      activeGroup: {
        key: group.key,
        label: group.label,
        mediaCount: group.mediaCount,
        orderCount: group.orders ? group.orders.length : 0,
        orderIds: (group.orders || []).map((o) => o._id || o.orderId).filter(Boolean),
      },
      modalVisible: true,
    })
  }

  closeModal = () => {
    this.setState({ modalVisible: false })
  }

  distinct = (key) =>
    _.uniq(this.state.orders.map((o) => o[key]).filter(Boolean))

  renderFilters = () => {
    const { dateRange, subCategory, user, orderId, status } = this.state
    return (
      <Card className={styles.filterBar} bodyStyle={{ paddingBottom: 0 }}>
        <Row gutter={12}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <RangePicker
              style={{ width: '100%', marginBottom: 12 }}
              value={dateRange}
              onChange={(val) => this.setState({ dateRange: val })}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Subcategory"
              value={subCategory}
              onChange={(val) => this.setState({ subCategory: val })}
            >
              {this.distinct('subCategory').map((c) => (
                <Option key={c} value={c}>
                  {c}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Select
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="User"
              value={user}
              onChange={(val) => this.setState({ user: val })}
            >
              {this.distinct('userName').map((u) => (
                <Option key={u} value={u}>
                  {u}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Input
              style={{ marginBottom: 12 }}
              placeholder="Order ID"
              value={orderId}
              allowClear
              onChange={(e) => this.setState({ orderId: e.target.value })}
              onPressEnter={this.handleSearch}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Status"
              value={status}
              onChange={(val) => this.setState({ status: val })}
            >
              {productionStatusList.map((s) => (
                <Option key={s} value={s}>
                  {s}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Button
              type="primary"
              icon="search"
              onClick={this.handleSearch}
              style={{ marginRight: 8, marginBottom: 12 }}
            >
              Search
            </Button>
            <Button icon="reload" onClick={this.handleReset} style={{ marginBottom: 12 }}>
              Reset
            </Button>
          </Col>
        </Row>
      </Card>
    )
  }

  getColumns = () => [
    {
      title: 'Order ID',
      key: 'orderId',
      width: 130,
      render: (val, r) =>
        r.orderId ? <b>#{r.orderId}</b> : <span style={{ color: '#bbb' }}>-</span>,
    },
    { title: 'User Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Category', dataIndex: 'category', key: 'category' },
    { title: 'Subcategory', dataIndex: 'subCategory', key: 'subCategory' },
    {
      title: 'Photos',
      key: 'photosCount',
      width: 90,
      render: (val, r) => (
        <Tag>
          <Icon type="picture" /> {Number(r.photosCount) || 0}
        </Tag>
      ),
    },
    {
      title: 'Videos',
      key: 'videosCount',
      width: 90,
      render: (val, r) => (
        <Tag>
          <Icon type="video-camera" /> {Number(r.videosCount) || 0}
        </Tag>
      ),
    },
    {
      title: 'Upload Date',
      key: 'uploadedDate',
      width: 140,
      render: (val, r) => fmt(r.uploadedDate || r.createdAt),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (val) => (
        <Tag className={styles.statusBadge} color={getProductionStatusColor(val || 'Pending')}>
          {val || 'Pending'}
        </Tag>
      ),
    },
  ]

  render() {
    const { loading, orders, total, page, pageSize, activeKeys, modalVisible, activeGroup } =
      this.state
    const groups = this.computeGroups(orders)
    const columns = this.getColumns()

    return (
      <PageHeaderWrapper title={`Outward Order List`}>
        {this.renderFilters()}

        <Card bordered>
          <Spin spinning={loading}>
            {groups.length === 0 ? (
              <div className={styles.emptyWrap}>
                <Icon type="inbox" style={{ fontSize: 36, display: 'block', marginBottom: 8 }} />
                No outward orders found
              </div>
            ) : (
              <Collapse
                bordered={false}
                className={styles.collapseWrap}
                activeKey={activeKeys}
                onChange={(keys) => this.setState({ activeKeys: keys })}
              >
                {groups.map((g) => (
                  <Panel
                    key={g.key}
                    extra={
                      <Button
                        type="primary"
                        size="small"
                        icon="eye"
                        onClick={(e) => {
                          e.stopPropagation()
                          this.openGroup(g)
                        }}
                      >
                        Review
                      </Button>
                    }
                    header={
                      <span className={styles.groupHeader}>
                        <span className={styles.groupDate}>{g.label}</span>
                        <span className={styles.countChip}>
                          <Icon type="picture" /> {plural(g.photosCount, 'Photo')}
                        </span>
                        <span className={styles.countDivider}>|</span>
                        <span className={styles.countChip}>
                          <Icon type="video-camera" /> {plural(g.videosCount, 'Video')}
                        </span>
                        <span className={styles.orderCount}>{plural(g.orders.length, 'Order')}</span>
                      </span>
                    }
                  >
                    <Table
                      className={styles.clickableTable}
                      size="small"
                      rowKey={(r) => r._id || r.orderId}
                      columns={columns}
                      dataSource={g.orders}
                      pagination={false}
                      onRow={() => ({
                        onClick: () => this.openGroup(g),
                      })}
                    />
                  </Panel>
                ))}
              </Collapse>
            )}

            <div className={styles.paginationBar}>
              <Pagination
                current={page}
                pageSize={pageSize}
                total={total}
                showSizeChanger
                pageSizeOptions={['10', '25', '50', '100']}
                showTotal={(t) => `Total ${t} orders`}
                onChange={this.onPageChange}
                onShowSizeChange={this.onPageChange}
              />
            </div>
          </Spin>
        </Card>

        <ReviewModal
          visible={modalVisible}
          group={activeGroup}
          onClose={this.closeModal}
          onUpdated={this.fetchList}
        />
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  loading: global.buttonLoading,
})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(OutwardOrderList)
